import { render, staticRenderFns } from "./manageCookie.vue?vue&type=template&id=3797f7bd"
import script from "./manageCookie.vue?vue&type=script&lang=js"
export * from "./manageCookie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports